const NavbarLinks = [
  {
    name: '$goin',
    refname: 'coin',
    activeRef: 'coin',
  },
  {
    name: 'info',
    refname: 'nextgen',
    activeRef: 'nextgen',
  },
  {
    name: 'game',
    refname: 'findway',
    activeRef: 'findway',
  },
  {
    name: 'roadmap',
    refname: 'roadmapSection',
    activeRef: 'roadmap',
  },
  {
    name: 'tokenomics',
    refname: 'tokenomics',
    activeRef: 'tokenomics',
  },
];

export default NavbarLinks;
